import * as ng from 'angular';
import { DropzoneMessage } from './dropzone-message.directive';


export const DropzoneMessageModule: string =
    ng.module('dropzone-message', [
    ])
        .directive('dropzoneMessage', DropzoneMessage)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/dropzone-message/dropzone-message.module.ts